import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoggedNav from "../components/LoggedNav";
import $ from "jquery";
import reminder from "../images/icons/reminder.png";
 import ReCAPTCHA from "react-google-recaptcha";
import Dialog from "@mui/material/Dialog";
import { Box, Typography } from "@mui/material";
import LinkPayment from "./LinkPayment";
import toast from "react-hot-toast";


function Reminder(props) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [bookerName, setBookerName] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);

  const updateMealPrep = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    
    
    if (!recaptchaToken) {
      setIsSubmitting(false);
      $(".validation").html("Please complete the reCAPTCHA");
      return;
    }
    

    // ✅ Checkbox validations
    if ($("input:checkbox[name=inp1]:checked").val() === undefined) {
      setIsSubmitting(false);
      $(".validation").html("Please turn off Burners/Oven");
    } else if ($("input:checkbox[name=inp2]:checked").val() === undefined) {
      setIsSubmitting(false);
      $(".validation").html("Please load the Dish Washer");
    } else if ($("input:checkbox[name=inp3]:checked").val() === undefined) {
      setIsSubmitting(false);
      $(".validation").html("Please clean the Kitchen");
    } else {
      $(".validation").html("");

      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}status/chef_meal_preparation_complete`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              booking_id: bookingId.toString(),
              status: "6",
            }),
          }
        );

        const parsedData = await res.json();

        if (parsedData.success === true) {
          // ✅ Clear localStorage after success
          localStorage.removeItem("reminder_bookingId");
          localStorage.removeItem("reminder_bookerName");

          setIsSubmitting(false);
          navigate("/chef/order-list", {
            state: { bookingId: bookingId, bookerName: bookerName },
          });
        } else {
          setIsSubmitting(false);
          setShowPaymentPopup(true); // Show popup
        }
      } catch (error) {
        setIsSubmitting(false);
        $(".validation").html("Error while submitting. Please check your connection.");
      }
    }
  };

  useEffect(() => {
    const title = "Reminder on Meal Prep Completion | CHEF | CHEF REPUBLIC";
    const desc =
      "This provides reminder to the Private Chef that once the order is complete, they must confirm that the burners are off, dish washer is loaded and kitchen is clean";

    document.title = title;
    document.querySelector("meta[name='title']")?.setAttribute("content", title);
    document.querySelector("meta[name='description']")?.setAttribute("content", desc);
    document.querySelector("meta[property='og:title']")?.setAttribute("content", title);
    document.querySelector("meta[property='og:description']")?.setAttribute("content", desc);
    document.querySelector("meta[property='twitter:title']")?.setAttribute("content", title);
    document.querySelector("meta[property='twitter:description']")?.setAttribute("content", desc);

    // ✅ Fallback to localStorage if state is undefined
    const savedBookingId = localStorage.getItem("reminder_bookingId");
    const savedBookerName = localStorage.getItem("reminder_bookerName");

    if (state?.bookingId || savedBookingId) {
      const finalBookingId = state?.bookingId || savedBookingId;
      setBookingId(finalBookingId);
      localStorage.setItem("reminder_bookingId", finalBookingId); // ensure it stays updated
    } else {
      navigate(-1);
    }

    if (state?.bookerName || savedBookerName) {
      const finalBookerName = state?.bookerName || savedBookerName;
      setBookerName(finalBookerName);
      localStorage.setItem("reminder_bookerName", finalBookerName);
    } else {
      navigate(-1);
    }
  }, [state, navigate]);

  // Handle PayPal return URL processing for reminder page
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const merchantId = urlParams.get("merchantIdInPayPal");
    const email = urlParams.get("email") || "example@paypal.com";
    
    if (merchantId) {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("logged_user_id");
      
      console.log("Token:", token);
      console.log("UserId:", userId);
      
      if (!token || !userId) {
        console.log("Token or userId missing");
        console.log("Please login to complete PayPal setup.");
        window.location.href = "/chef/sign-in";
        return;
      }
      
      console.log(`Merchant connected: ${merchantId}`);
      saveMerchantIdToBackend(merchantId, email);

      // Clean up URL after processing
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  const saveMerchantIdToBackend = async (merchantId, email) => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("logged_user_id");
      
      const res = await fetch(
        "https://chefrepublicwebapi-dev.portalwiz.in/api/user/add_chef_account",
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token
          },
          body: JSON.stringify({
            user_id: userId,
            merchantId,
            Email: email,
            merchantIdInPayPal: merchantId,
            permissionsGranted: true,
            accountStatus: "active",
            consentStatus: "active",
            isEmailConfirmed: "true",
            returnMessage: "Onboarding complete",
          }),
        }
      );

      let data = {};
      try {
        data = await res.json();
      } catch (jsonErr) {
        console.error("Error parsing JSON response:", jsonErr);
        console.log("Invalid server response.");
        return;
      }

      if (res.ok && data.success) {
        console.log("Merchant ID saved successfully.");
      } else if (res.status === 401) {
        console.log("Authentication failed. Please login again.");
        localStorage.clear();
        window.location.href = "/chef/sign-in";
      } else {
        console.log(data.message || "Failed to save Merchant ID.");
      }

    } catch (err) {
      console.log("Error saving Merchant ID.");
      console.error("Save merchant error:", err);
    }
  };

  return (
    <>
      <LoggedNav customer={props.customer} />

      <div
        className="container d-flex flex-column justify-content-center align-items-center"
        style={{ width: "95%", margin: "auto", height: "80vh" }}
      >
        <div
          className="logo text-center fw-bold my-5 p-3"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#ff5e41",
            color: "white",
            borderRadius: "50%",
            fontSize: "2.5rem",
            height: "100px",
            width: "100px",
          }}
        >
          <img src={reminder} alt="reminder" style={{ width: "95%" }} />
        </div>

        <div className="header text-center fw-bold my-3">
          <h1 className="fw-bold">Reminder</h1>
        </div>

        <div className="d-flex flex-column">
          <div className="form-check m-3">
            <input className="form-check-input shadow-none" type="checkbox" value={1} name="inp1" />
            <label className="form-check-label" style={{ color: "#00000087", fontSize: "0.9rem", marginLeft: "5px" }}>
              Please confirm that the Burners and oven if used are turned off
            </label>
          </div>

          <div className="form-check m-3">
            <input className="form-check-input shadow-none" type="checkbox" value={1} name="inp2" />
            <label className="form-check-label" style={{ color: "#00000087", fontSize: "0.9rem", marginLeft: "5px" }}>
              Please confirm that the dish washer is loaded
            </label>
          </div>

          <div className="form-check m-3">
            <input className="form-check-input shadow-none" type="checkbox" value={1} name="inp3" />
            <label className="form-check-label" style={{ color: "#00000087", fontSize: "0.9rem", marginLeft: "5px" }}>
              Please confirm the kitchen is clean.
            </label>
          </div>
        </div>

        <p style={{ color: "red", fontSize: "0.8rem" }} className="validation text-center"></p>

        {/* Google reCAPTCHA v2 above Confirm button */}
        <div className="mb-3 text-center">
          <ReCAPTCHA
            sitekey="6LfuoXMrAAAAAHUTukwdB3cFf0m2RA5HfPFJnHAf"
            onChange={(token) => setRecaptchaToken(token)}
          />
        </div>

        <div className="submit text-center my-3 mx-3">
          <button onClick={updateMealPrep} className="btn-orange" disabled={isSubmitting}>
            {isSubmitting ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : (
              ""
            )}{" "}
            Confirm
          </button>
        </div>
      </div>

      {/* Payment Method Popup */}
      <Dialog
        open={showPaymentPopup}
        onClose={() => setShowPaymentPopup(false)}
        PaperProps={{
          sx: {
            borderRadius: "20px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            maxWidth: 400,
          },
        }}
      >
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontSize: "16px", mb: 2, mt: 2 }}>
            Please link your PayPal Business account to accept payments
          </Typography>

          <LinkPayment />
        </Box>
      </Dialog>
    </>   
  );
}

export default Reminder;
